import React from "react";
import { Link } from "react-router-dom";

const BannerHeroCollection = ({ backgroundImage, title, description, buttonText, buttonLink }) => {
  return (
    <>
      <style>
        {`
          .banner-hero-collection-wrap {
            max-width: 1600px !important;
            margin: 0 auto !important;
            padding-left: 20px !important;
            padding-right: 20px !important;
            box-sizing: border-box !important;
          }

          @media (max-width: 575px) {
            .banner-hero-collection-wrap {
              max-width: 100% !important;
              padding-left: 12px !important;
              padding-right: 12px !important;
            }
          }

          @media (min-width: 576px) and (max-width: 767px) {
            .banner-hero-collection-wrap {
              max-width: 100% !important;
              padding-left: 16px !important;
              padding-right: 16px !important;
            }
          }

          @media (min-width: 768px) and (max-width: 991px) {
            .banner-hero-collection-wrap {
              max-width: 1200px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          @media (min-width: 992px) and (max-width: 1199px) {
            .banner-hero-collection-wrap {
              max-width: 1400px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          @media (min-width: 1400px) {
            .banner-hero-collection-wrap {
              max-width: 1600px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }
        `}
      </style>
    <section
      className="banner-hero-collection-wrap banner-parallax"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="box-content">
        <div className="container">
          <Link
            to={buttonLink || "/shop/collection"}
            className="card-box text-md-start text-center rounded-0"
          >
            {title && <h3 className="heading font-caprasimo">{title}</h3>}
            {description && <p className="text">{description}</p>}
            {buttonText && (
              <div className="wow fadeInUp" data-wow-delay="0s">
                <button className="tf-btn style-2 btn-fill animate-hover-btn font-caprasimo text-uppercase letter-2">
                  <span>{buttonText}</span>
                </button>
              </div>
            )}
          </Link>
        </div>
      </div>
    </section>
    </>
  );
};

export default BannerHeroCollection;

